import { TranslateService } from '@ngx-translate/core';
import { ControlPanelService } from './../../../../states/control-panel.service';
import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ControlPanelStore } from 'src/states/control-panel.store';
import { Observable } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { ParametresGlobauxDto } from 'src/api/models';
import { ControlPanel } from 'src/states/control-panel.actions';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

 // @Select(ControlPanelStore.user$) user$: Observable<UserDto>;

  @Select(ControlPanelStore.globalParams$) globalParams$: Observable<ParametresGlobauxDto>;

  @Output()
  menuToggle = new EventEmitter<boolean>();

  @Input()
  menuToggleEnabled = false;

  @Input()
  title: string;

  userMenuItems = [];
  paramsGlobaux: ParametresGlobauxDto = { SiteName: "" };

 // u: UserDto;
  gp: any;

  constructor(
    private controlPanelService: ControlPanelService,
    private panelLayoutService: PanelLayoutService,
    private router: Router,
    private store: Store,
    private translateService: TranslateService) {
    }

  ngOnInit() {
    this.gp = this.globalParams$.subscribe(res => {
      if (res != null) {
        this.paramsGlobaux = res;
      }
    });
    this.translateService.get('Logout').subscribe( r => {
      this.userMenuItems = [
        // My Profile
        /*{
          text: this.translateService.instant('Navigation.Profile'),
          icon: 'user',
          onClick: () => {
            this.router.navigate(['/parametres','profil']); // TODO
          }
        },
        {
          text: '-'
        },*/
        // Log out
        {
          text: r,
          icon: 'runner',
          onClick: () => {
            this.controlPanelService.logout();
          }
        }
      ];
      /*this.user$.subscribe( u => {
        if (u) {
          this.u = u;
          this.updateRegisteredHandsets();
        }
      });*/
    });
  }

  ngOnDestroy() {
    this.gp?.unsubscribe();
  }

  GetLogo() {
    return this.panelLayoutService.GetLogo();
  }

  toggleMenu = () => {
    this.menuToggle.emit();
  }

}
